import { IsEnum, IsNumber, IsOptional, Length, Max, Min } from 'class-validator';

import { LocationTypeEnum } from '@onArte/shared/database/enums';

export class LocationModel {
  @IsEnum(LocationTypeEnum)
  public type: LocationTypeEnum;

  @IsNumber()
  @Min(-90)
  @Max(90)
  public latitude: number;

  @IsNumber()
  @Min(-180)
  @Max(180)
  public longitude: number;

  @Length(1, 64)
  public country: string;

  @Length(1, 128)
  public city: string;

  @IsOptional()
  @Length(1, 6)
  public postalCode: string | null;

  @IsOptional()
  @Length(1, 128)
  public street: string | null;

  @IsOptional()
  @Length(1, 8)
  public houseNumber: string | null;

  @IsOptional()
  @Length(1, 8)
  public apartmentNumber: string | null;

  constructor(
    type: LocationTypeEnum,
    latitude: number,
    longitude: number,
    country: string,
    city: string,
    postalCode: string | null,
    street: string | null,
    houseNumber: string | null,
    apartmentNumber: string | null
  ) {
    this.type = type;
    this.latitude = latitude;
    this.longitude = longitude;
    this.country = country;
    this.city = city;
    this.postalCode = postalCode;
    this.street = street;
    this.houseNumber = houseNumber;
    this.apartmentNumber = apartmentNumber;
  }
}
